import { FC } from "react";
import { Route as ReactRoute, Switch } from "react-router-dom";

import { Route } from "App/router";
import { venueRoutes } from "Venues/router";
import { FourOhFour } from "shared/pages";
import { Layout } from "shared/layout";
import { IUser } from "Auth/types";
import { authRoutes } from "Auth/router";
import { ProfileProvider } from "Auth/contexts";

interface VenuesRouterProps {
  currentUser: IUser | null;
  handleOpenCookies: () => void;
}

const VenuesRouterComponent: FC<VenuesRouterProps> = ({ currentUser, handleOpenCookies }) => {
  return (
    <Layout currentUser={currentUser || undefined} handleOpenCookies={handleOpenCookies}>
      <Switch>
        {venueRoutes.map((route, index) => (
          <Route key={index} {...route} />
        ))}
        {authRoutes.map((route, index) => (
          <Route key={index} {...route} />
        ))}
        <ReactRoute component={FourOhFour} />
      </Switch>
    </Layout>
  );
};

export const VenuesRouter: FC<VenuesRouterProps> = props => (
  <ProfileProvider>
    <VenuesRouterComponent {...props} />
  </ProfileProvider>
);
